import React, { useState } from 'react';
import AnalyticsCard from './components/AnalyticsCard';
import styled from 'styled-components';
import { Select } from 'antd';
import { CredusText, CredusWrapper } from 'ui';
import {
  IOverviewProps,
  OverviewTestDataProps,
} from './overview-models/overview.Interface';

const AnalyticsData = ({ data, setSort }: IOverviewProps) => {
  const [duration, setDuration] = useState<string>('Month');
  const { Option } = Select;
  const handleSelectChange = (value: unknown) => {
    setDuration(value as string);
    setSort && setSort(value as 'Month' | 'Week');
  };
  return (
    <div>
      <CredusWrapper display="flex" justify="space-between" align="center">
        <CredusText weight="bold" size="md">
          Recent Tests
        </CredusText>
        <CustomSelect onChange={handleSelectChange} value={duration}>
          <Option value="Month"> A month</Option>
          <Option value="Week"> A week</Option>
        </CustomSelect>
      </CredusWrapper>
      <CredusText
        mt="0.6rem"
        size="sm"
        weight="medium"
        color="rgba(0, 0, 0, 0.5);"
      >
        A {duration as string} ago
      </CredusText>
      <WrapperDiv>
        {data?.tests?.map((test: OverviewTestDataProps, i: number) => (
          <AnalyticsCard key={i} test={test} />
        ))}
      </WrapperDiv>
    </div>
  );
};

export default AnalyticsData;

const WrapperDiv = styled.div`
  margin-top: 0.625rem;
  height: 18rem;
  overflow-y: auto;
  position: relative;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 8px;
    background: rgba(0, 9, 41, 0.18);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f2f2;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 20px;
  }
`;

export const CustomSelect = styled(Select)`
  width: 99.19px;

  background: #fff1ef !important;
  border-radius: 5px;
`;
